<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>邀约与征稿</el-breadcrumb-item>
          <el-breadcrumb-item>图片邀约管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt="">
        <p>刷新</p>
      </div>
    </div>

    <div v-if="!isPic"
         class="main">
      <div class="head">
        <h4>图片邀约管理<span v-if="powersObj.manageAllPictureNeed"
                :style="{'cursor': 'pointer','marginLeft':'15px','fontSize':'12px','color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}"
                @click="seeAll">{{isAllFlag}}</span></h4>
        <p @click="openDialog" :style="{'color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}">+发布邀约</p>
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <picinvitemanagetable :tableData="picInviteList"
                                @seePic="seePic"
                                @authClick="authClick"
                                @changeClick="changeClick"
                                @delectClick="delectClick"></picinvitemanagetable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>

      </div>
    </div>

    <div v-if="isPic"
         class="main">
      <div class="head">
        <h4>发布图片邀约</h4>
      </div>
      <div class="tablebg">
        <div style="width:calc(100% - 300px);margin:0 auto;padding:20px;">
          <picinvitemanageform :ruleForm="ruleForm"
                               @closeForm="closeForm"
                               @submitForm="submitForm"></picinvitemanageform>
          <!-- <el-button @click="dialogFormVisible = true">弹框表单</el-button> -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { picinvitemanagetable, picinvitemanageform } from '@/components/index'
import { mapGetters } from "vuex";
import { listPictureNeed, updatePictureNeed, addPictureNeed, getPictureNeed, deletePictureNeed } from "@/api/pictureNeed";
import { getUser } from "@/api/user";
import { getDate, formatConversion } from "@/plugins/getdate";
import { powersObj } from "@/constants/powers";
export default {
  components: {
    'picinvitemanagetable': picinvitemanagetable,
    'picinvitemanageform': picinvitemanageform
  },
  computed: {
    ...mapGetters(["createUid"]),
  },

  data () {
    return {
      //权限
      powersObj,

      total: 0,
      currentPage: 1,
      pageSize: 10,
      isPic: false,
      picInviteList: [],
      ruleForm: {
        title: "",
        type: "",
        appointUids: "0",
        appointUidsName: "",
        appointUidsId: "",
        desc: "",
        content: "",
        status: "0",
        createUid: this.createUid
      },
      isRefresh: false,
      timeInt: '',

      //所有
      isAll: 0,
      isAllFlag: '查看所有'
    };
  },
  methods: {

    seeAll () {
      if (this.isAll === 0) {
        this.isAllFlag = '查看个人'
        this.isAll = -1
        this.handleCurrentChange(1)
      } else {
        this.isAllFlag = '查看所有'
        this.isAll = 0
        this.handleCurrentChange(1)
      }
    },



    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data
      data = { page: (this.currentPage - 1), pageSize: this.pageSize, createUid: this.isAll }
      // console.log(data)
      this.listPictureNeedAsync(data)
    },


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },



    openDialog () {
      this.isPic = !this.isPic
      this.ruleForm = {
        title: "",
        type: "",
        appointUids: "0",
        appointUidsName: "",
        appointUidsId: "",
        desc: "",
        content: "",
        status: "0",
        createUid: this.createUid
      }
    },
    closeForm () {
      this.isPic = !this.isPic
      this.ruleForm = {
        title: "",
        type: "",
        appointUids: "0",
        appointUidsName: "",
        appointUidsId: "",
        desc: "",
        content: "",
        status: "0",
        createUid: this.createUid
      }
    },
    submitForm (data) {

      // console.log(data)
      if (data.id) {
        this.updatePictureNeedAsync(data)
      } else {
        this.addPictureNeedAsync(data)
      }
      this.ruleForm = {
        title: "",
        type: "",
        appointUids: "0",
        appointUidsName: "",
        appointUidsId: "",
        desc: "",
        content: "",
        status: "0",
        createUid: this.createUid
      }
      this.$notify({
        title: '友情提示',
        message: '请刷新页面后查看！'
      });
    },
    //关闭事件
    authClick (data) {
      this.$confirm("确认修改状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          if (data.row.status === 0) {
            data.row.status = 1
          } else {
            data.row.status = 0
          }
          this.updatePictureNeedAsync(data.row)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });

    },
    //查看图片
    seePic (data) {
      this.$router.push({
        path: '/pictureNeed/show',
        query: {
          id: data.row.id
        }
      })
    },
    //修改事件
    changeClick (data) {
      this.getPictureNeedAsync(data.row.id)
      // this.ruleForm = {...data.row}
      // if(this.ruleForm.appointUids !== "0"){
      //   this.ruleForm.appointUidsId = this.ruleForm.appointUids
      //   this.ruleForm.appointUids = "1"
      //   let aUNList = this.ruleForm.appointUidsId.split(',')
      //   this.ruleForm.appointUidsName = ''
      //   for (let i = 0; i < aUNList.length; i++) {
      //     let id = parseInt(aUNList[i])
      //     this.getUserAsync(id)
      //   }
      // }


      setTimeout(() => {
        this.isPic = !this.isPic
      }, 800);
    },
    //删除事件
    delectClick (data) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.deletePictureNeedAsync(data.row.id)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },



    //查询用户
    async getUserAsync (val) {

      let { status, data, message, errors } = await getUser(val);
      if (status) {
        this.ruleForm.appointUidsName += data.name + ';'
        // console.log(this.ruleForm)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },




    //获取图片邀约列表
    async listPictureNeedAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listPictureNeed(val);
      if (status) {
        this.picInviteList = data;
        this.total = pagination.total
        for (let i = 0; i < this.picInviteList.length; i++) {
          this.picInviteList[i].createAtMY = formatConversion(this.picInviteList[i].createAt.toString())
        }

        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },

    //查询图片邀约
    async getPictureNeedAsync (val, flag) {
      let { status, data, message, errors } = await getPictureNeed(val);
      if (status) {
        this.ruleForm = { ...data }
        if (this.ruleForm.appointUids !== "0") {
          this.ruleForm.appointUidsId = this.ruleForm.appointUids
          this.ruleForm.appointUids = "1"
          let aUNList = this.ruleForm.appointUidsId.split(',')
          this.ruleForm.appointUidsName = ''
          for (let i = 0; i < aUNList.length; i++) {
            let id = parseInt(aUNList[i])
            this.getUserAsync(id)
          }
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //删除图片邀约
    async deletePictureNeedAsync (val) {
      let { status, data, message, errors } = await deletePictureNeed(val);
      if (status) {
        this.$message.success("删除成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改图片邀约信息
    async updatePictureNeedAsync (val) {
      let { status, data, message, errors } = await updatePictureNeed(val);
      if (status) {
        this.isPic = false
        this.$message.success("修改成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加图片邀约
    async addPictureNeedAsync (val) {
      let { status, data, message, errors } = await addPictureNeed(val);
      if (status) {
        this.isPic = false
        this.$message.success("添加成功！");
        this.handleCurrentChange(1);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    }











  },

  created () {
    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./picinvitemanage.scss";

h4 {
  font-size: 18px;
}
</style>
